import {
  GET_CENTER_CONTENT,
  POST_CENTER_CONTENT,
  DELETE_OR_PATCH_CONTENT,
  ASSOCIATE_CONTENT_AND_PATIENT
} from "resources/ApiUrls"
import MyAxiosInstance from "utils/MyAxiosInstance"

const getAll = (userId) => MyAxiosInstance.get(GET_CENTER_CONTENT(userId))

const create = (contentObj) => MyAxiosInstance.post(POST_CENTER_CONTENT, contentObj)

const remove = (contentId) => MyAxiosInstance.delete(DELETE_OR_PATCH_CONTENT(contentId))

const update = (contentId, fieldsToUpdate) => MyAxiosInstance.patch(DELETE_OR_PATCH_CONTENT(contentId), fieldsToUpdate)

const associateContentAndPatient = (association) => MyAxiosInstance.post(ASSOCIATE_CONTENT_AND_PATIENT, association)

const messagesAPICalls = { getAll, create, remove, update, associateContentAndPatient }

export default messagesAPICalls